import { render, staticRenderFns } from "./NewestPostsPanel.vue?vue&type=template&id=2365e444&scoped=true&"
import script from "./NewestPostsPanel.vue?vue&type=script&lang=js&"
export * from "./NewestPostsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NewestPostsPanel.vue?vue&type=style&index=0&id=2365e444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365e444",
  null
  
)

export default component.exports